import { useState } from "react";
import { api, setAdminToken } from "../api";

export function LoginGate({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [token, setToken] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token.trim()) {
      setError("请输入访问 Token");
      return;
    }
    setBusy(true);
    setError(null);
    setAdminToken(token);
    try {
      await api.meta();
      onLoggedIn();
    } catch (err: unknown) {
      const e = err as Error & { status?: number };
      setError(e.status === 401 ? "Token 无效" : e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex h-full items-center justify-center bg-ink-50 p-6">
      <form onSubmit={submit} className="card w-full max-w-md space-y-4 p-8">
        <div>
          <h1 className="text-lg font-semibold">AVM License Server</h1>
          <p className="mt-1 text-sm text-ink-500">请输入管理员 Token 以继续</p>
        </div>
        <div>
          <label className="label">AVM_ADMIN_TOKEN</label>
          <input
            className="input font-mono text-sm"
            type="password"
            autoComplete="current-password"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="Bearer Token"
          />
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button className="btn-primary w-full" type="submit" disabled={busy}>
          {busy ? "验证中…" : "登录"}
        </button>
      </form>
    </div>
  );
}
